export const ADMIN = 'admin'
export const FOND = 'fond'
export const ATB = 'atb'
export const COUNT = 'count'
export const FUMEGATSIYA = 'fumigatsiya'
export const ACCOUNTANT = 'accountant'
export const STATISTIK_HISOBOT = 'stat'